/**
 * Uniwersalna obsługa błędów technicznych (AJAX, sieć)
 */
app.service('ajaxErrorHandler', function (modal, console) {

	const DEFAULT_USER_MESSAGE = "Wystąpił problem techniczny. Sprawdź połączenie internetowe i spróbuj ponownie.";

	/**
	 * Obsługuje błąd AJAX - loguje szczegóły i informuje użytkownika
	 * @param {jqXHR} jqXHR - obiekt błędu jQuery AJAX
	 * @param {string} textStatus - status tekstowy błędu
	 * @param {string} errorThrown - opis błędu
	 * @param {Object} options - opcje dodatkowe
	 * @param {string} options.context - kontekst operacji (do logowania)
	 * @param {string} options.userMessage - własna wiadomość dla użytkownika
	 */
	function handleAjaxError(jqXHR, textStatus, errorThrown, options = {}) {
		const context = options.context || 'Unknown';
		const userMessage = options.userMessage || DEFAULT_USER_MESSAGE;

		logError(jqXHR, textStatus, errorThrown, context);
		notifyUser(userMessage);
	}

	function logError(jqXHR, textStatus, errorThrown, context) {
		const errorDetails = {
			context: context,
			status: jqXHR && jqXHR.status,
			statusText: jqXHR && jqXHR.statusText,
			textStatus: textStatus,
			errorThrown: errorThrown,
			responseText: jqXHR && jqXHR.responseText && jqXHR.responseText.substring(0, 500),
			timestamp: new Date().toISOString()
		};

		console.error(context, errorDetails);
	}

	function notifyUser(message) {
		modal.alert(message);
	}

	/**
	 * Tworzy handler do użycia w .fail()
	 * @param {string} context - kontekst operacji
	 * @param {string} userMessage - opcjonalna własna wiadomość
	 * @returns {Function}
	 */
	function createFailHandler(context, userMessage = '') {
		return function (jqXHR, textStatus, errorThrown) {
			handleAjaxError(jqXHR, textStatus, errorThrown, {context, userMessage});
		};
	}

	return {
		handleAjaxError,
		createFailHandler
	};
});
